import React from 'react'
import './publication.scss'

export class PublicationComponent extends React.Component {
    render() {
        return (
            <div>Publication</div>
        );
    }
}
